import type { StepAccent } from 'cpool-components/general/Stepper/types';
import type { LOANREQUEST_STATUS } from 'cpool-constants';
import { LOANREQUEST_STATUSES } from 'cpool-constants';

type LoanRequestStatusColors = {
    pill: string;
    step: Required<StepAccent>;
};

export const LOANREQUEST_STATUS_COLORS: Record<LOANREQUEST_STATUS, LoanRequestStatusColors> = {
    [LOANREQUEST_STATUSES.INITIAL]: {
        pill: 'bg-loan-status-initial-pastel border-loan-status-initial-strong text-loan-status-initial-strong',
        step: {
            active: { fillClass: 'fill-loan-status-initial-pastel', textClass: 'text-loan-status-initial-strong' },
            badgeClass: 'bg-loan-status-initial-pastel text-loan-status-initial-strong',
        },
    },
    [LOANREQUEST_STATUSES.IN_PROGRESS]: {
        pill: 'bg-loan-status-in-progress-pastel border-loan-status-in-progress-strong text-loan-status-in-progress-strong',
        step: {
            active: {
                fillClass: 'fill-loan-status-in-progress-pastel',
                textClass: 'text-loan-status-in-progress-strong',
            },
            badgeClass: 'bg-loan-status-in-progress-pastel text-loan-status-in-progress-strong',
        },
    },
    [LOANREQUEST_STATUSES.OFFER_AT_CUSTOMER]: {
        pill: 'bg-loan-status-offer-customer-pastel border-loan-status-offer-customer-strong text-loan-status-offer-customer-strong',
        step: {
            active: {
                fillClass: 'fill-loan-status-offer-customer-pastel',
                textClass: 'text-loan-status-offer-customer-strong',
            },
            badgeClass: 'bg-loan-status-offer-customer-pastel text-loan-status-offer-customer-strong',
        },
    },
    [LOANREQUEST_STATUSES.OFFER_AT_BANK]: {
        pill: 'bg-loan-status-offer-bank-pastel border-loan-status-offer-bank-strong text-loan-status-offer-bank-strong',
        step: {
            active: {
                fillClass: 'fill-loan-status-offer-bank-pastel',
                textClass: 'text-loan-status-offer-bank-strong',
            },
            badgeClass: 'bg-loan-status-offer-bank-pastel text-loan-status-offer-bank-strong',
        },
    },
    [LOANREQUEST_STATUSES.APPROVED]: {
        pill: 'bg-loan-status-approved-pastel border-loan-status-approved-strong text-loan-status-approved-strong',
        step: {
            active: { fillClass: 'fill-loan-status-approved-pastel', textClass: 'text-loan-status-approved-strong' },
            badgeClass: 'bg-loan-status-approved-pastel text-loan-status-approved-strong',
        },
    },
    [LOANREQUEST_STATUSES.CANCELED]: {
        pill: 'bg-loan-status-canceled-pastel border-loan-status-canceled-strong text-loan-status-canceled-strong',
        step: {
            active: { fillClass: 'fill-loan-status-canceled-pastel', textClass: 'text-loan-status-canceled-strong' },
            badgeClass: 'bg-loan-status-canceled-pastel text-loan-status-canceled-strong',
        },
    },
};
